import { memo } from 'react'
import { DgtPdOrderPicklist } from '../models'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { AiFillMinusCircle } from 'react-icons/ai'
import { IoMdAddCircle } from 'react-icons/io'

const RemoveItemConfirmEditor = memo(({ props } : {
  props: EditorProps<DgtPdOrderPicklist>
}) => {
  const { onClose, onRowChange, row } = props

  return row.deprecated ? <Modal show={true} onHide={onClose}
    okTheme='success'
    okText='เพิ่ม'
    okAction={() => {
      let updatedRow = { ...row }
      delete updatedRow.deprecated
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title='คำเตือนเนื่องจากมีการเปลี่ยนแปลงใบเบิก'
    >
    <div className='flex items-center gap-2'>
      <IoMdAddCircle size={50} className='text-green-500 basis-1/6 ' />
      <div className='space-y-2 basis-5/6'>
        <h6>คุณกำลังเอา Item</h6>
        <h5 className='font-bold underline '>{row.materialCode} - {row.materialDescription}</h5>
        <h6>เข้าใบเบิก แน่ใจแล้วหรือไม่ ?</h6>
      </div>
    </div>
  </Modal> :
  <Modal show={true} onHide={onClose}
    okTheme='danger'
    okText='เอาออก'
    okAction={() => {
      const updatedRow = { ...row,
        deprecated: true
      }
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title={`คำเตือนเนื่องจากมีการเปลี่ยนแปลงใบเบิก`}
    >
    <div className='flex items-center gap-2'>
      <AiFillMinusCircle size={50} className='text-red-500 basis-1/6 ' />
      <div className='space-y-2 basis-5/6'>
        <h6>คุณกำลังเอา Item</h6>
        <h5 className='font-bold underline '>{row.materialCode} - {row.materialDescription}</h5>
        <h6>ออกจากใบเบิก แน่ใจแล้วหรือไม่ ?</h6>
      </div>
    </div>
    
  </Modal>
})

export default memo(RemoveItemConfirmEditor)